import { createSelector } from 'reselect';
import { GEOFENCES } from '../constants/geofence.constants';
import { initialState } from '../reducers/geofence.reducer';
import {ADMIN_PAGE} from "../../containers/AdminPage/constants";
import {fromJS, List} from "immutable";

const selectState = state => state?.[GEOFENCES] || initialState;
const selectAdminState = state => state?.[ADMIN_PAGE] || fromJS({});

const selectGeofencesData = createSelector(
	selectState,
	state => state.get('data')
);

const selectGeofencesList = createSelector(
	[selectGeofencesData, selectAdminState],
	(data, adminState) => {
		const geofences = data.toList();
		if(!geofences?.size) {
			return List(adminState.get('geofences'));
		}
		return geofences;
	}
);

export const selectGeofences = createSelector(
	selectGeofencesList,
	geofences => geofences.sortBy(g => g.name.toLowerCase())
);

export const selectPresence = createSelector(
	selectState,
	state => state.get('presence')
);

export const selectDetailedGeofence = createSelector(
	selectState,
	state => state.get('detailedGeofence')
);

export const selectLoadingDetailedGeofence = createSelector(
	selectState,
	state => state.get('loading')
);

export const selectGeofencesFetched = createSelector(
	selectState,
	state => state.get('fetched')
);